import { ReactElement } from 'react'
import { Flex, Grid, Heading, SVG, Text } from '../..'
import { PriceContainer, ServiceContainer, StyledPackageCard } from './styles'
import { PackageCardProps } from './props'

const PackageCard = ({
    multiplier,
    price,
    save,
    service,
    ...props
}: PackageCardProps): ReactElement => (
    <StyledPackageCard {...props}>
        <ServiceContainer>
            <Heading level={4} bold>
                {service.name}
            </Heading>
            <Grid autoFlow="column">
                <Flex gap={4}>
                    <Heading level={3} size={1}>
                        {multiplier}x{service.durationMin}
                    </Heading>
                    <Text size="xl">min</Text>
                </Flex>
                <SVG src={service.icon} />
            </Grid>
        </ServiceContainer>
        <PriceContainer>
            <Grid autoFlow="column" gap={8}>
                <Text>{price.label}</Text>
                <Text bold>{price.value},-</Text>
            </Grid>
            <Grid>
                <Text bold>
                    {save.label} {save.value},-
                </Text>
            </Grid>
        </PriceContainer>
    </StyledPackageCard>
)

export default PackageCard

export { StyledPackageCard }
